import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import LaneChip from './LaneChip';
import { formatDate, formatHrs1, formatPct } from './historyFormatters';
import {
  tableSx,
  headSx,
  groupHeadSx,
  numSx,
  valueSx,
  dividerLeftSx,
  subHeadStickySx,
} from './historyTableStyles';

/**
 * WeeklySnapshotsTable — two-row header grouping Shop/Field hours. Columns:
 * Week ending | Status | Shop % | Field % | Act shop | Earned shop |
 * Act field | Earned field. Oldest first (from API) so it reads as a timeline.
 */
function WeeklySnapshotsTable({ rows = [] }) {
  if (!rows.length) {
    return <div className="phm-empty">No records found.</div>;
  }

  return (
    <Table size="small" stickyHeader sx={tableSx}>
      <TableHead>
        <TableRow>
          <TableCell sx={headSx} rowSpan={2}>
            Week ending
          </TableCell>
          <TableCell sx={headSx} rowSpan={2}>
            Status
          </TableCell>
          <TableCell sx={{ ...headSx, ...numSx }} rowSpan={2}>
            Shop %
          </TableCell>
          <TableCell sx={{ ...headSx, ...numSx }} rowSpan={2}>
            Field %
          </TableCell>
          <TableCell sx={{ ...groupHeadSx, ...dividerLeftSx }} colSpan={2}>
            Shop
          </TableCell>
          <TableCell sx={{ ...groupHeadSx, ...dividerLeftSx }} colSpan={2}>
            Field
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            sx={{ ...headSx, ...numSx, ...dividerLeftSx, ...subHeadStickySx }}
          >
            Act hrs
          </TableCell>
          <TableCell sx={{ ...headSx, ...numSx, ...subHeadStickySx }}>
            Earned hrs
          </TableCell>
          <TableCell
            sx={{ ...headSx, ...numSx, ...dividerLeftSx, ...subHeadStickySx }}
          >
            Act hrs
          </TableCell>
          <TableCell sx={{ ...headSx, ...numSx, ...subHeadStickySx }}>
            Earned hrs
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((r, i) => (
          <TableRow key={i}>
            <TableCell sx={valueSx}>{formatDate(r.weekEnding)}</TableCell>
            <TableCell>
              <LaneChip name={r.statusName} />
            </TableCell>
            <TableCell sx={numSx}>{formatPct(r.shopPercentComplete)}</TableCell>
            <TableCell sx={numSx}>
              {formatPct(r.fieldPercentComplete)}
            </TableCell>
            <TableCell sx={{ ...numSx, ...dividerLeftSx }}>
              {formatHrs1(r.actualShopHrsToDate)}
            </TableCell>
            <TableCell sx={numSx}>
              {formatHrs1(r.earnedShopHrsToDate)}
            </TableCell>
            <TableCell sx={{ ...numSx, ...dividerLeftSx }}>
              {formatHrs1(r.actualFieldHrsToDate)}
            </TableCell>
            <TableCell sx={numSx}>
              {formatHrs1(r.earnedFieldHrsToDate)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default WeeklySnapshotsTable;
